import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-courses-details-page',
    templateUrl: './courses-details-page.component.html',
    styleUrls: ['./courses-details-page.component.scss']
})
export class CoursesDetailsPageComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

    pageTitleArea: pageTitle[] = [
        {
            title: 'GEO-Desk',
            subTitle: 'Hoe werkt het dan precies?'
        }
    ]

}
class pageTitle {
    title : string;
    subTitle: string;
}
